<script lang="ts">
	import classNames from 'classnames';
	import type { Component } from 'svelte';
	import { twMerge } from 'tailwind-merge';
	import { ChevronRightIcon } from '../../../../assets/icons/ChevronRightIcon';
	import { Link } from '../../../../components/Link';
	import { Txt } from '../../../../components/Txt';

	let {
		classes = {},
		Icon = undefined,
		href,
		title,
		subtitle,
		src = undefined,
		onClick = undefined,
		newTab = undefined,
		...rest
	}: Props = $props();

	interface Props {
		class?: string;
		classes?: { title?: string; icon?: string; chevron?: string };
		Icon?: Component | undefined;
		href: string | undefined;
		title: string;
		subtitle: string | undefined;
		src?: string | undefined;
		onClick?: (() => void) | undefined;
		newTab?: boolean | undefined;
	}
</script>

<Link
	class={twMerge(
		'flex cursor-pointer items-center justify-between gap-2 p-2 [&_p]:hover:underline',
		rest.class
	)}
	{href}
	{...newTab ? { rel: 'noopener noreferrer', target: '_blank' } : {}}
	onclick={onClick as () => void}
>
	<div class={classNames('flex gap-3', { 'items-center': !subtitle || !title })}>
		{#if src}
			<img
				class="h-6 min-h-[1.5rem] w-6 min-w-[1.5rem] rounded-full object-cover"
				{src}
				alt={title}
			/>
		{:else if Icon}
			<Icon class={twMerge('h-5 w-5', classes?.icon)} />
		{/if}
		<div class={classNames({ 'mt-[-0.25rem]': subtitle && title })}>
			<Txt variant="label4" class={classes?.title}>{title}</Txt>

			{#if subtitle}
				<Txt variant="label4" class="text-gray-500">{subtitle}</Txt>
			{/if}
		</div>
	</div>

	<ChevronRightIcon class={twMerge('h-3 min-h-[0.75rem] w-3 min-w-[0.75rem]', classes?.chevron)} />
</Link>
